<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import ActivityComponent from './ActivityComponent.vue'

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const { user, milestone } = this.activity
      const creator = user.uuid === this.self.uuid ? this.$t('You') : user.name

      return `${creator} detached milestone <strong>"${milestone.name}"</strong> from this task.`
    },
  },
}
</script>
